import brandlive from '@/themes/brandlive';
import brandlive_old from '@/themes/brandlive-old';
import webinarPlus from '@/themes/webinar-plus';
import brandTV from '@/themes/brandtv';
import { Theme, ThemeName } from '@/types/theme';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { useAppSelector } from '@/store/hooks';
import { selectFeatureFlag } from '@/store/slices/feature-flags/selectors';
import { FeatureFlagsEnum } from '@/store/slices/feature-flags/types';

export function useTheme(): { theme: Theme | null; usePjdTheme: boolean } {
  const [searchParams, setSearchParams] = useSearchParams();
  const [theme, setTheme] = useState<Theme | null>(null);
  const pjdOn = useAppSelector(selectFeatureFlag(FeatureFlagsEnum.project_details_full));

  useEffect(() => {
    const themeParam = searchParams.get('theme');
    switch (themeParam) {
      case ThemeName.WEBINAR_PLUS:
        setTheme(webinarPlus);
        break;
      case ThemeName.BRANDTV:
        setTheme(brandTV);
        break;
      default:
        pjdOn ? setTheme(brandlive) : setTheme(brandlive_old);
    }
  }, [searchParams, pjdOn]);

  useEffect(() => {
    // Put theme in search params if PJD is on, so the form actions can access the PJD themes
    if (theme && theme.name !== searchParams.get('theme') && pjdOn) {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set('theme', theme.name);
      setSearchParams(newSearchParams);
    }
  }, [theme, searchParams, pjdOn, setSearchParams]);

  return { theme, usePjdTheme: theme !== brandlive_old };
}
